import { FC } from 'react'
import { currencyFormatted } from '@yuno/sdk-web-core/dist/utils'
import {
  ButtonPay,
  Container,
  TotalContent,
  TotalPrice,
  TotalTitle,
} from './payment-methods-mobile.styled'
import { usePaymentMethodsMobile } from './use-payment-methods-mobile'
import { ButtonExternalContent, PaymentMethodsContent } from '../payment-methods.styled'
import { SecureCopy } from '../secure-copy'
import { useTranslation } from 'react-i18next'

export const PaymentMethodsMobile: FC = () => {
  const { currency, totalDue, onStartPayment } = usePaymentMethodsMobile()
  const { t } = useTranslation()

  return (
    <Container show={true}>
      <TotalContent>
        <TotalTitle>{t('Total amount')}</TotalTitle>
        <TotalPrice>
          {currencyFormatted(
            currency,
            totalDue
          )}{' '}
          {currency}
        </TotalPrice>
      </TotalContent>

      <PaymentMethodsContent>
        <div id="root-sdk"></div>
        <ButtonExternalContent>
          <div id="paypal"></div>
        </ButtonExternalContent>
      </PaymentMethodsContent>
      <ButtonPay onClick={onStartPayment}>{t('Continue')}</ButtonPay>
      <SecureCopy />
    </Container>
  )
}
